import {
    EDIT_INTERVIEWER_STATUS_REQUEST,
    EDIT_INTERVIEWER_STATUS_SUCCESS,
    EDIT_INTERVIEWER_STATUS_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editInterviewerStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_INTERVIEWER_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_INTERVIEWER_STATUS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_INTERVIEWER_STATUS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editInterviewerStatusReducer;
